var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerSettingsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "184 -782.15 592 598.15",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464-432v-350.15h32V-432zm16 248q-62.31 0-115.92-23.05-53.61-23.04-93.8-63.23t-63.23-93.8Q184-417.69 184-480.16q0-67.38 30.19-128.07t83.04-102.54l22.54 22.54Q270-651 243-596.5T216-480q0 110 77.25 187t186.53 77Q590-216 667-293t77-187q0-61.84-26.5-116.92t-77.27-91.31l22.54-22.54q54.61 41.85 83.92 102.34Q776-547.93 776-480q0 62.31-23.14 115.92t-63.4 93.8q-40.27 40.19-94.1 63.23Q541.54-184 480-184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSettingsNew);
export default __webpack_public_path__ + "static/media/power_settings_new.f00f03125cdd40173e74d9806ec3bac3.svg";
export { ForwardRef as ReactComponent };